import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = { class: "text-box" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "text-gray mr-3"
}
const _hoisted_6 = {
  key: 2,
  class: "banner-button"
}
const _hoisted_7 = { class: "bt-icon bt-icon--xs" }
const _hoisted_8 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", {
    class: ["banner-container", {
            'gray-banner': _ctx.isGrayBanner,
            'blue-banner': _ctx.isBlueBanner,
            'orange-banner': _ctx.isOrangeBanner,
        }]
  }, [
    (_ctx.isGrayBanner)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_InlineSvgScoped, {
            src: require(`@/assets/images/icon-check.svg`),
            "aria-label": "icon-blueprint"
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isBlueBanner || _ctx.isOrangeBanner)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["icon-warning", { orange: _ctx.isOrangeBanner }]
        }, [
          _createVNode(_component_InlineSvgScoped, {
            class: "fill-icon",
            src: 
                    require(`@/assets/images/icons/icon-alert-medium-full.svg`)
                ,
            "aria-label": "icon-blueprint"
          }, null, 8, ["src"])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.subtitle), 1),
      (_ctx.showLastSyncData)
        ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.bannerDetails), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isVisibleSyncButton)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "p-button-rounded p-button-outlined px-4",
            disabled: !_ctx.enableSyncButton,
            onClick: _ctx.onClickSyncNow
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_InlineSvgScoped, {
                  src: require(`@/assets/images/icons/icon-sync.svg`),
                  "aria-label": "icon-grid"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.SyncNow")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}